import type { FavoritesRootContextMenuProps } from "./components/FavoritesRootContextMenu";
import type { FavoriteNodeContextMenuProps } from "./components/FavoriteNodeContextMenu";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "FavoriteContextMenu" */ "./lazyIndex"), { name: "FavoriteContextMenu" });

// Delay loaded components
export const FavoriteNodeContextMenu: LazyComponent<FavoriteNodeContextMenuProps, unknown, void> = createLazyComponent(lazyModule, m => m.FavoriteNodeContextMenu);

export const FavoritesRootContextMenu: LazyComponent<FavoritesRootContextMenuProps, unknown, void> = createLazyComponent(lazyModule, m => m.FavoritesRootContextMenu);

export const lazySelectFavoritePlaceholderNode: LazyImport<typeof lazyIndex.selectFavoritePlaceholderNode, typeof lazyModule> = new LazyImport(lazyModule, m => m.selectFavoritePlaceholderNode);
